import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;
const announcementsURL = `${baseURL}/course-offer-announcements`;

export const getCourseOffersAnnouncements = (
  pageNo,
  pageSize,
  params,
  sortBy,
  sortOrder
) => {
  const queries = Object.assign(
    { pageNo, pageSize, sortOrder, sortBy },
    params
  );

  return axios.get(announcementsURL, { params: queries });
};

export const getSingleCourseOffersAnnouncement = (id) =>
  axios.get(`${announcementsURL}/${id}`);

export const addCourseOfferAnnouncement = async (params) =>
  await axios.post(announcementsURL, params);

export const updateCourseOfferAnnouncement = async (id, params) =>
  await axios.put(`${announcementsURL}/${id}`, params);

export const sendBid = async (id, role) =>
  await axios.post(`${announcementsURL}/${id}/bids/${role}`);

export const cancelBid = async (id, role) =>
  await axios.delete(`${announcementsURL}/${id}/bids/${role}`);

export const updateSelectedTrainers = async (id, params) =>
  await axios.patch(`${announcementsURL}/${id}/selections`, params);

export const sendRetractRequestFromCourseOffer = async (id, body) =>
  await axios.post(`${announcementsURL}/${id}/retracts`, body);

export const getAvailableTrainers = async (id) =>
  await axios.get(`${announcementsURL}/${id}/trainers`);
